// @flow

import { takeLatest, put, call, select } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import { closeSearchNotificationConfirmDeleteModal } from './actions';
import {
  deleteSearchNotificationSuccess,
  deleteSearchNotificationError,
} from '../SearchNotifications/actions';
import { DELETE_SEARCH_NOTIFICATION_REQUEST } from './actionTypes';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import {
  confirmedDeletionSearchNotificationSelector,
  notificationApiParamsSelector,
} from '../selectors';
import { searchNotificationsSelector } from '../SearchNotifications/selectors';
import { openSnackbarError, closeSnackbar } from '../Snackbar/actions';

const notificationsApi = new ApiNotifications(clientConfig.notificationApi);

export function* deleteSearchNotificationSaga(): Saga<void> {
  yield put(closeSnackbar());

  const notification = yield select(confirmedDeletionSearchNotificationSelector);
  const searchNotificationsState = yield select(searchNotificationsSelector);

  yield put(deleteSearchNotificationSuccess(notification));
  yield put(closeSearchNotificationConfirmDeleteModal());

  const apiParams = yield select(notificationApiParamsSelector);

  try {
    yield call(
      [notificationsApi, notificationsApi.deleteSearchNotification],
      apiParams,
      notification
    );
  } catch (error) {
    yield put(openSnackbarError());
    yield put(deleteSearchNotificationError(searchNotificationsState));
  }
}

export default function* sagas(): Saga<void> {
  yield takeLatest(DELETE_SEARCH_NOTIFICATION_REQUEST, deleteSearchNotificationSaga);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/DeleteSearchNotification/sagas.js